import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { CreateAgentFormData } from "../schema/CreateAgentSchema";
import { AgentResponseSchema } from "../response/CreateAgentResponse";

export const useCreateAgent = () => {
    return useMutation({
        mutationFn: async (formData: CreateAgentFormData) => await privateApi.post(`/v3/agent`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = AgentResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid agent data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create agent', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid agent data format");
            } else {
                console.error(`Failed to create agent`, error);
                throw error;
            }
        }
    });
};